import styled from 'styled-components';

export const CreateEditPartnerWrapper = styled.div`
    h1 {
        font-size: 2.5rem;
    }

    h4, label {
      text-align: right;
      width: 100%;
    }
    
    .editPartnerSection {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;
    }

    .separator {
        border-inline-end: 1px solid var(--bllink-purple);
    }

    .bllink-button {
        width: 300px;
    }

    .upload-wrapper {
      display: flex;
      flex-direction: column;
    }

    .file-upload-btn {
        width: 300px;
        position: relative;
        height: 52px;
        padding: 0 20px 0 62px;
        font-weight: bold;
        font-size: 15px;
        line-height: 23px;
        cursor: pointer;
        
        border-radius: 50px;
        border: 1px solid var(--bllink-purple);
        background-color: #fff;
        .file-name {
          display: block;
          max-width: 200px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: pre;
        }
    }

    .control-with-icon {
        position: relative;
        &.search {
          &::after {
            top: 0;
            left: 0;
          }
        }
        &::after {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          border: 1px solid var(--bllink-blue);
        }
        img {
          position: absolute;
          left: 26px;
          top: 26px;
          transform: translate(-50%, -50%);
        }
      }
`